var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body me-3 position-relative",staticStyle:{"width":"200px"}},[_c('div',{staticClass:"mt-2"},[_c('el-progress',{attrs:{"percentage":_vm.process}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }